import { WorkflowItemWrapper } from "./workflow-item-wrapper.model";
import { BaseModel } from "../base.model";

export class Workflow extends BaseModel{            
    Title: string;
    CurrentStep: number;
    Status: number;
    ExecutionVariables: any;
    InitiationParameters: any;        
    WorkflowItems: WorkflowItemWrapper;
    
    constructor() {
        super();                
    }

}



